import { h } from 'preact'; /** @jsx h */

import './PaymentInfo.scss';

const PaymentInfo = ({ cart, paymentMethod, setPaymentMethod }) => {
    // Check if any product in the cart has a shipmentType
    const hasShipmentType = cart.some(product => product.shipmentType);

    return (
        <div className="ws-order-user-info">
            <div className="user-info-header action">
                <div className="header-content">
                    <span className="header-number">{hasShipmentType ? '3' : '2'}</span>
                    <h6 className="header-title">Betalingsalternativ</h6>
                </div>
                <div className="header-action"></div>
            </div>
            <div className="user-info-content">
                <div className="payment-option">
                    <input
                        className="payment-radio"
                        type="radio"
                        id="vipps"
                        name="payment"
                        value="vipps"
                        checked={paymentMethod === 'vipps'}
                        onChange={e => setPaymentMethod(e.target.value)}
                    />
                    <label htmlFor="vipps" className="payment-label">
                        <div className="radio-text">
                            <span className="radio-custom"></span>
                            <span className="option-text">Vipps</span>
                        </div>
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2023/12/vipps-logo-oransje.png"
                            alt="Vipps logo"
                        />
                    </label>
                </div>
                <div className="payment-option">
                    <input
                        className="payment-radio"
                        type="radio"
                        id="visa"
                        name="payment"
                        value="visa"
                        checked={paymentMethod === 'visa'}
                        onChange={e => setPaymentMethod(e.target.value)}
                    />
                    <label htmlFor="visa" className="payment-label">
                        <div className="radio-text">
                            <span className="radio-custom"></span>
                            <span className="option-text">Visa</span>
                        </div>
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2023/12/visa-logo.png"
                            alt="Visa logo"
                        />
                    </label>
                </div>
                <div className="payment-option">
                    <input
                        className="payment-radio"
                        type="radio"
                        id="mastercard"
                        name="payment"
                        value="mastercard"
                        checked={paymentMethod === 'mastercard'}
                        onChange={e => setPaymentMethod(e.target.value)}
                    />
                    <label htmlFor="mastercard" className="payment-label">
                        <div className="radio-text">
                            <span className="radio-custom"></span>
                            <span className="option-text">Mastercard</span>
                        </div>
                        <img
                            src="https://norskluftambulanse.no/wp-content/uploads/2023/12/mastercard-logo.png"
                            alt="Mastercard logo"
                        />
                    </label>
                </div>
            </div>
        </div>
    );
};

export default PaymentInfo;
